import { useEffect, useState } from "react";
import GetUserInfoService from "../service/GetUserInfoService";
import useApiStatus from "./useApiStatus";

const useGetDashboard = ({ onError, filter }) => {
  const { isLoading, setIsLoading, hasError, setHasError } = useApiStatus();
  const [dashboardData, setDashboardData] = useState([]);

  const getUserInfoService = new GetUserInfoService();

  const loadDashboardData = async () => {
    try {
      setIsLoading(true);
      const res = await getUserInfoService.getDashboard(
        filter.dateBegin,
        filter.dateEnd,
        filter.filter
      );
      if (res.messageCode !== 200001) {
        setHasError(true);
        onError(res.messageCode);
      } else {
        setHasError(false);
        setDashboardData(res.result);
      }
    } catch (e) {
      setHasError(true);
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadDashboardData();
    return () => {
      setIsLoading(false);
      setHasError(false);
      setDashboardData([]);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    loadDashboardData(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  return {
    isLoading,
    dashboardData,
    hasError,
  };
};

export default useGetDashboard;
